import { render, staticRenderFns } from "./SimilarityItem.vue?vue&type=template&id=85c6f6fa&scoped=true&"
import script from "./SimilarityItem.vue?vue&type=script&lang=ts&"
export * from "./SimilarityItem.vue?vue&type=script&lang=ts&"
import style0 from "./SimilarityItem.vue?vue&type=style&index=0&id=85c6f6fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85c6f6fa",
  null
  
)

export default component.exports